import { render, staticRenderFns } from "./ServiceAttentionAdd.vue?vue&type=template&id=2f848cb3"
import script from "./ServiceAttentionAdd.vue?vue&type=script&lang=js"
export * from "./ServiceAttentionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports